import { ensureIsResourcesFolder, isResourcesFolder, Item, ResourcesFolder } from '@ael/core-api';
import { createSelector } from 'reselect';
import {AppStore} from '../models/Store';

/** Creates a selector for retrieving resources item. */
export const createGetResourcesFolderItemSelector = createSelector(
  (store: AppStore) => store.items,
  (items): ResourcesFolder | undefined => {
    const resourcesFolder = items.find((item: Item) => isResourcesFolder(item));
    if (resourcesFolder) {
      ensureIsResourcesFolder(resourcesFolder);
    }
    return resourcesFolder;
  }
);
